<script setup lang="ts">
import type { ChatChip } from 'src/composables/hybrid-chat/types';

defineProps<{
  chips: ChatChip[];
  disabled?: boolean;
}>();

const emit = defineEmits<{
  (e: 'select', chip: ChatChip): void;
}>();

const { t } = useI18n();
</script>

<template lang="pug">
.ai-chips
  button.ai-chips__chip(
    v-for="(chip, i) in chips"
    :key="i"
    :disabled="disabled"
    @click="emit('select', chip)"
  ) {{ t(chip.labelKey) }}
</template>

<style lang="sass">
.ai-chips
  display: flex
  flex-wrap: wrap
  gap: 6px
  margin-top: 8px

  &__chip
    background: rgba(255, 255, 255, 0.06)
    border: 1px solid rgba(255, 255, 255, 0.12)
    border-radius: 16px
    padding: 6px 12px
    color: rgba(255, 255, 255, 0.85)
    font-size: 12px
    cursor: pointer
    transition: background 0.2s, border-color 0.2s
    white-space: nowrap

    &:hover:not(:disabled)
      background: rgba(255, 255, 255, 0.1)
      border-color: rgba(255, 255, 255, 0.2)

    &:disabled
      opacity: 0.4
      cursor: not-allowed
</style>
